import React from 'react';
import { StaticContext } from 'react-router';
import { RouteComponentProps, withRouter } from 'react-router-dom';

export function withRouterInnerRef<P>(WrappedComponent: React.ComponentType<P>) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, max-len
  const InnerComponentWithRef: React.FC<RouteComponentProps<any, StaticContext, unknown> & { forwardRef: unknown }> = (
    props,
  ) => {
    const { forwardRef, ...rest } = props;

    return <WrappedComponent {...(rest as unknown as P)} ref={forwardRef} />;
  };

  const InnerComponentWithRouter = withRouter(InnerComponentWithRef);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return React.forwardRef((props: P, ref) => <InnerComponentWithRouter {...props} forwardRef={ref} />);
}

export default withRouterInnerRef;
